import { render, staticRenderFns } from "./IconTargetClient.vue?vue&type=template&id=28b8ec96&"
import script from "./IconTargetClient.vue?vue&type=script&lang=js&"
export * from "./IconTargetClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports